module.exports = __webpack_public_path__ + "img/horizontal_6_5_9005.eac7c9e3.png";